// extracted by mini-css-extract-plugin
export default {"root":"InlinePdfViewer__root___jdsOw"};